import React from "react";
import { Outlet } from "react-router-dom";

const MetaAdsLayout = () => {
  return (
    <div className="relative min-h-[60vh]">
      <Outlet />
    </div>
  );
};

export default MetaAdsLayout;
